<script lang="ts">
  import { Link } from "svelte-routing";
</script>

<div class="min-h-screen bg-white flex items-center justify-center">
  <div class="text-center">
    <h1 class="text-4xl md:text-6xl font-light mb-6">404</h1>
    <p class="text-xl text-gray-700 mb-8">Project not found</p>
    <Link to="/" class="text-[#F96604] hover:underline">
      Back to Home →
    </Link>
  </div>
</div> 